'use strict';

import progress from '../utils/progress';
const util = require('../utils/util');

let formIsBeingSubmitted = false;

/**
 *  Handles saving of preference center settings via AJAX
 * @param {jQuery} $form
 */
const handlePreferencesForm = $form => {
    formIsBeingSubmitted = true;
    progress.show($form);
    const $preferenceCenter = $form.closest('.preference-center-main');
    const $message = $preferenceCenter.find('.message');
    const $disabledInputs = $form.find(':disabled');
    let $headerHeight;

    $message.removeClass('response-visible');
    $disabledInputs.prop('disabled', false);
    const formData = $form.serialize();
    $disabledInputs.prop('disabled', true);
    $.ajax({
        dataType: 'json',
        method: 'POST',
        url: $form.attr('action'),
        data: formData,
        success: response => {
            formIsBeingSubmitted = false;
            progress.hide();
            if (response.success) {
                $message.not('.error-form').addClass('response-visible');
                if (util.isMobile()) {
                    $headerHeight = $('.new-header').height();
                } else {
                    $headerHeight = $('.header-wrapper').height();
                }

                let scrollToSuccessMessage = $('.message.success-form.response-visible').offset().top - $headerHeight;

                $('html, body').animate(
                    {
                        scrollTop: scrollToSuccessMessage
                    },
                    500
                );
            } else {
                $message.not('.success-form').addClass('response-visible');
            }
        },
        error: response => {
            formIsBeingSubmitted = false;
            progress.hide();
            $message.not('.success-form').addClass('response-visible');
        }
    });
};

/**
 * Handles checkbox click - updates the aria-checked property of the checkbox
 * and marks selected options as "disabled" if more should not be unselected.
 * @param {JQuery} $input
 */
const handleCheckboxClick = $input => {
    $input.attr('aria-checked', $input.prop('checked'));

    const $question = $input.parents('.question-container');
    const minimumRequired = $question.data('min-required') || 0;
    const selectedOptions = $question.find('input:checked');

    if (minimumRequired > 0 && selectedOptions.length <= minimumRequired) {
        selectedOptions.parents('.input-container').addClass('minimum-required');
        selectedOptions.prop('disabled', true);
        selectedOptions.attr('aria-disabled', true);
    }

    if (minimumRequired > 0 && selectedOptions.length > minimumRequired) {
        selectedOptions.parents('.input-container').removeClass('minimum-required');
        selectedOptions.prop('disabled', false);
        selectedOptions.attr('aria-disabled', false);
    }
};

/**
 * Loads the preference center after a successful COI subscription
 * or hides it on unsubscribing
 * @param {JQuery} $container
 * @param {JQuery.Event} data
 */
const togglePreferenceCenter = ($container, data) => {
    if (data.action === 'subscribe' && data.optInType === 'COI') {
        $container.addClass('loading');
        $.ajax({
            dataType: 'html',
            method: 'get',
            url: $container.data('url'),
            success: response => {
                $container.html(response);
                $container.removeClass('loading');
            }
        });
    } else if (data.action === 'unsubscribe') {
        $container.html('');
    }
};

export const initPreferenceCenterEvents = () => {
    const $prefCenter = $('#preference-center-include');

    if (!$prefCenter.data('enabled')) {
        return;
    }

    $prefCenter.on('click', '.checkbox-input', e => {
        const $input = $(e.currentTarget);
        handleCheckboxClick($input);
    });

    $prefCenter.on('click', 'input[name*="newsletter_product"]', e => {
        if ($('input[name*="newsletter_product"]').attr('aria-checked') == 'true') {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'newsletterPreferences_switch',
                    dl_newsletterPreferences: 'Birkenstock'
                });
            }
        }
    });

    $prefCenter.on('click', 'input[name*="newsletter_1774"]', () => {
        if ($('input[name*="newsletter_1774"]').attr('aria-checked') == 'true') {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'newsletterPreferences_switch',
                    dl_newsletterPreferences: '1774'
                });
            }
        }
    });

    $prefCenter.on('click', '.save-preferences', () => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'newsletterPreferences_settings'
            });
        }
    });

    $prefCenter.on('click', 'button[type="submit"]', e => {
        e.preventDefault();
        if (!formIsBeingSubmitted) {
            const $submitButton = $(e.currentTarget);
            const $form = $submitButton.closest('form');
            handlePreferencesForm($form);
        }
    });

    window.addEventListener('customer.subscriptionChanged', e => {
        togglePreferenceCenter($prefCenter, e.detail);
    });
};
